import {
    transition,
    trigger,
    query,
    style,
    animate,
    animateChild
} from '@angular/animations';
export const fadeInAnimation =
    trigger('fadeInAnimation', [
        transition('* <=> *', [
            style({
                position: 'relative',
                minHeight: 'calc(100vh - 100px)'
            }),
            query(':enter',
                [
                    style({ opacity: 0 }),
                    animateChild()
                ],
                { optional: true }
            ),
            query(':enter,:leave', [
                style({
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%'
                })
            ], { optional: true }),
            query(':leave',
                [
                    style({ opacity: 1 }),
                    animate('.3s', style({ opacity: 0 })),
                    animateChild()
                ],
                { optional: true },
            ),
            query(':enter',
                [
                    style({ opacity: 0 }),
                    animate('.3s', style({ opacity: 1 })),
                    animateChild()
                ],
                { optional: true }
            )
        ])
    ]);

export const moduleFadeInAnimation =
    trigger('moduleFadeInAnimation', [
        transition('* <=> *', [
            style({
                position: 'relative',
                minHeight: 'calc(100vh - 100px)'
            }),
            query(':enter',
                [
                    style({ opacity: 0 }),
                    animateChild()
                ],
                { optional: true }
            ),
            query(':enter,:leave', [
                style({
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%'
                })
            ], { optional: true }),
            query(':leave',
                [
                    style({ opacity: 1 }),
                    animate('.2s', style({ opacity: 0 })),
                    animateChild()
                ],
                { optional: true },
            ),
            query(':enter',
                [
                    style({ opacity: 0 }),
                    animate('.2s', style({ opacity: 1 })),
                    animateChild()
                ],
                { optional: true }
            )
        ])
    ]);
